<template>
  <div class="add-feedback-photo">
    <span class="profile-icon">
      <img :src="imageUrl" alt />
      <span class="icon-Btn uploadicon">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11">
          <g>
            <path
              d="M13.424 1.73c-.277-.291-.66-.463-1.095-.463h-2.191v-.026c0-.33-.132-.647-.357-.858-.224-.225-.528-.357-.858-.357h-3.96c-.343 0-.647.132-.871.357-.224.224-.356.528-.356.858v.026H1.558c-.436 0-.819.172-1.096.462C.185 2.006 0 2.402 0 2.825v6.573c0 .436.172.819.462 1.096.277.277.673.462 1.096.462h10.77c.436 0 .82-.172 1.096-.462.278-.277.462-.673.462-1.096V2.825c0-.436-.171-.819-.462-1.096zM13.2 9.397h-.013c0 .238-.093.45-.251.608-.158.158-.37.25-.607.25H1.558c-.238 0-.45-.092-.608-.25-.158-.159-.25-.37-.25-.608V2.825c0-.238.092-.449.25-.607.159-.159.37-.251.608-.251h2.547c.198 0 .357-.159.357-.357v-.382c0-.146.052-.278.145-.37.092-.092.224-.145.37-.145h3.946c.145 0 .277.053.37.145.092.092.145.224.145.37v.382c0 .198.158.357.356.357h2.548c.238 0 .449.092.607.25.159.159.251.37.251.608v6.573z"
            />
            <path
              d="M6.943 2.864c-.897 0-1.716.37-2.297.95-.594.595-.95 1.4-.95 2.298 0 .897.37 1.716.95 2.296.594.594 1.4.95 2.297.95.898 0 1.716-.369 2.297-.95.594-.594.95-1.399.95-2.296 0-.898-.37-1.716-.95-2.297-.58-.581-1.4-.95-2.297-.95zM8.738 7.92c-.462.449-1.095.74-1.795.74s-1.333-.291-1.795-.74c-.462-.462-.74-1.096-.74-1.795 0-.7.291-1.333.74-1.795.462-.462 1.096-.74 1.795-.74.7 0 1.333.29 1.795.74.462.462.74 1.095.74 1.795.013.7-.278 1.333-.74 1.795z"
            />
            <circle cx="11.642" cy="3.498" r="1" />
          </g>
        </svg>
        <label class="file">
          <input
            type="file"
            id="file"
            ref="myFiles"
            accept="image/*"
            class="upload-photo"
            @change="uploadPhoto"
            multiple
          />
        </label>
      </span>
    </span>
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import constant from "../utils/constant";
import { getBase64Url } from "../utils/helper";

export default {
  props: {
    imageUrl : {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      imagePreview: [],
      userPhotoFile: require('../assets/images/userimg.jpg'),
    };
  },
  methods: {
    async uploadPhoto(file) {
      const image = file.target.files[0];
      if (!image.type.includes("image/")) {
        alert("Please select an image file");
        return;
      }
      const formData = new FormData();
      this.loading = true;
      formData.append("image", image, image.name);
      formData.append("isResizeRequired", true);
      await axios
        .post(constant.FILE_UPLOAD_URL, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(data => {
          this.userPhotoFile = data.data.mediaVariantDTOs[0].url;
          this.loading = false;
          console.log( typeof this.userPhotoFile);
          this.$emit("uploadImageList", this.userPhotoFile);
        })
        .catch(err => {
          console.log("FAILURE", err);
        });
    }
  }
};
</script>
<style>
.loader {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #e5dcdc36;
  z-index: 9;
}
.loader p {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -45%);
  font-weight: 600;
  padding: 5px;
  background: #000000bd;
  color: #fff;
  border-radius: 10px;
}
.profile-icon {
  width: 70px;
  height: 70px;
  border-radius: 100px;
  position: relative;
  overflow: hidden;
}
.profile-icon .uploadicon {
  position: absolute;
  right: 0px;
  bottom: -4px;
  background: #ffffff;
  border-radius: 100px;
  -webkit-box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.15);
}
.icon-Btn {
  width: 32px;
  height: 32px;
  position: relative;
}
.profile-icon .uploadicon svg {
  fill: #505050;
  width: 16px;
  height: 16px;
}
.profile-icon .uploadicon .upload-photo {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 11;
    opacity: 0;
}
</style>
